import classNames from 'classnames';
import React, { useCallback } from 'react';
import { PhoneInputWUT } from './phone-input/phone-input-wut';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description';
import { FieldLabelWUT } from '../field-label';
import { FieldErrorWUT } from '../field-error';
import { useTpaStyleParams } from '../shared/use-tpa-style-params';
import { classes } from './phone-input-field-wut.st.css';
import { useInvokeCallback } from '../shared/use-invoke-callback';
import { toE164 } from './format-phone-number';
import { useExperiments } from '../../contexts/experiments-context';
import { EXPERIMENTS } from '../../constants';
import { TextFieldTheme } from 'wix-ui-tpa/cssVars';
export const PhoneInputFieldWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    placeholder,
    required = false,
    description,
    value = '',
    defaultCountry,
    showFlag,
    validation,
    onChange,
    onBlur,
    onFocus,
    error,
    disabled = false,
    customErrors,
    fieldType,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = _ref;
  const {
    isExperimentEnabled
  } = useExperiments();
  const useCSSVars = isExperimentEnabled(EXPERIMENTS.USE_CSS_VARS_ONLY);
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const {
    hasError,
    errorMessage
  } = useError(error, customErrors, fieldType);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const {
    inputTheme,
    isBorderStyleNone
  } = useTpaStyleParams();
  const invokeBlur = useInvokeCallback(onBlur);
  const handleBlur = useCallback(() => {
    const e164PhoneNumber = typeof value === 'string' && value ? toE164(value) : value;
    onChange(e164PhoneNumber);
    invokeBlur();
  }, [value, onChange, invokeBlur]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => {
      var _validation$string;
      return /*#__PURE__*/React.createElement(PhoneInputWUT, {
        id: inputId,
        hasError: hasError,
        value: value ? value : '',
        className: classNames(classes.textField, {
          [FIELD_ERROR_CLASS]: hasError,
          [classes.noBorder]: isBorderStyleNone && !useCSSVars,
          [classes.hover]: forcedHover,
          [classes.theme]: useCSSVars
        }),
        onChange: onChange,
        required: required,
        disabled: disabled,
        placeholder: placeholder,
        onBlur: handleBlur,
        onFocus: onFocus,
        theme: useCSSVars ? TextFieldTheme.Box : inputTheme,
        noBorder: isBorderStyleNone && !useCSSVars,
        ariaDescribedBy: ariaDescribedBy,
        ariaInvalid: hasError,
        showFlag: showFlag,
        defaultCountry: defaultCountry,
        allowedCountryCodes: validation == null || (_validation$string = validation.string) == null || (_validation$string = _validation$string.phoneOptions) == null ? void 0 : _validation$string.allowedCountryCodes
      });
    },
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=phone-input-field-wut.js.map